<style lang="postcss">
	:global(body),
	:global(html) {
		margin: 0;
		padding: 0;
	}
	#error-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		height: 100dvh;
		color: #333;
		font-family: Arial, sans-serif;
		min-height: 180px;
	}
	#error-container.iframe {
		height: fit-content;
		flex-direction: flex-start;
		align-items: flex-start;
		padding-left: 1.5rem;
		border-radius: 4px;
		box-shadow: 0 0 0 1.5px #333 inset;
	}

	.status-code {
		font-size: 4em;
		font-weight: bold;
		margin: 0 auto 2rem auto;
	}
	#error-container.iframe .status-code {
		font-size: 3em;
		margin: 0 0 0.75rem 0;
	}

	.svg {
		width: 100px;
		height: 100px;
		margin-top: 2rem;
		margin-bottom: 1.5rem;
	}

	#error-container.iframe .svg {
		height: 48px;
		width: 48px;
		margin-top: 1rem;
		margin-bottom: 0.75rem;
	}

	.error-message {
		font-size: 1.4em;
		margin-bottom: 2rem;
	}
	#error-container.iframe .error-message {
		margin-bottom: 1.5rem;
	}
</style>

<script lang="ts">
	import { page } from "$app/stores";
	const iframe = $page.url.searchParams.get("iframe") === "true";
</script>

<svelte:body class="error-body" />

{#if iframe}
	{@html `
	<script type="module">
		if (typeof window !== "undefined") {
			const form = document.getElementById("error-container");
			const formStyles = getComputedStyle(form);
			const height = parseFloat(formStyles.height.replace("px", "") + 2);
			if (!isNaN(height)) {	
				window.parent.postMessage({
					type: "height",
					content: height
				},"*");				
			}
		}
	</script>
`}
{/if}

<div id="error-container" class:iframe="{iframe}">
	<svg xmlns="http://www.w3.org/2000/svg" class="svg" viewBox="0 0 20 20">
		<path
			fill="currentColor"
			d="M8.5 8.5a1 1 0 1 1-2 0a1 1 0 0 1 2 0m4 1a1 1 0 1 0 0-2a1 1 0 0 0 0 2m.303 2.5c-1.274 0-2.52.377-3.58 1.084a.5.5 0 0 0 .554.832A5.454 5.454 0 0 1 12.803 13h.797a.5.5 0 0 0 0-1zM2 10a8 8 0 1 1 16 0a8 8 0 0 1-16 0m8-7a7 7 0 1 0 0 14a7 7 0 0 0 0-14"
		></path>
	</svg>
	<h1 class="status-code">{$page.status}</h1>
	<div class="error-message">{$page.error?.message}</div>
</div>
